// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['bn_IN']  = {
  "name": "bn_IN",
  "day": {
    "abbrev": [
      "রবি",
      "সোম",
      "মঙ্গল",
      "বুধ",
      "বৃহস্পতি",
      "শুক্র",
      "শনি"
    ],
    "full": [
      "রবিবার",
      "সোমবার",
      "মঙ্গলবার",
      "বুধবার",
      "বৃহস্পতিবার",
      "শুক্রবার",
      "শনিবার"
    ]
  },
  "month": {
    "abbrev": [
      "জানুয়ারি",
      "ফেব্রুয়ারি",
      "মার্চ",
      "এপ্রিল",
      "মে",
      "জুন",
      "জুলাই",
      "আগস্ট",
      "সেপ্টেম্বর",
      "অক্টোবর",
      "নভেম্বর",
      "ডিসেম্বর"
    ],
    "full": [
      "জানুয়ারি",
      "ফেব্রুয়ারি",
      "মার্চ",
      "এপ্রিল",
      "মে",
      "জুন",
      "জুলাই",
      "আগস্ট",
      "সেপ্টেম্বর",
      "অক্টোবর",
      "নভেম্বর",
      "ডিসেম্বর"
    ]
  },
  "meridiem": [
    "পূর্বাহ্ণ",
    "অপরাহ্ণ"
  ],
  "date": "%A %d %b %Y",
  "time24": "%I:%M:%S  %Z",
  "dateTime": "%A %d %b %Y %I:%M:%S %p %Z",
  "time12": "%I:%M:%S %p %Z"
}

